import * as React from 'react';
import { ColumnDefinition, ColumnId, useTableColumnVisibility } from '../hooks/useTableColumnVisibility';

interface TableColumnVisibilityContextValue {
	columns: ColumnDefinition[];
	visibleColumns: ColumnDefinition[];
	visibleColumnCount: number;
	maxVisibleColumns: number;
	canAddMoreColumns: boolean;
	updateColumnVisibility: (columnId: ColumnId, isVisible: boolean) => void;
	resetToDefaults: () => void;
}

const TableColumnVisibilityContext = React.createContext<TableColumnVisibilityContextValue | null>(null);

export const useTableColumnVisibilityContext = (): TableColumnVisibilityContextValue => {
	const context = React.useContext(TableColumnVisibilityContext);
	if (!context) {
		throw new Error('useTableColumnVisibilityContext must be used within a TableColumnVisibilityProvider');
	}
	return context;
};

export const TableColumnVisibilityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const value = useTableColumnVisibility();

	return <TableColumnVisibilityContext.Provider value={value}>{children}</TableColumnVisibilityContext.Provider>;
};
